import {
    NOTIFICATIONS_MARK_AS_READ,
    NOTIFICATIONS_NEW_ONE_CREATED,
    NOTIFICATIONS_SET_UNREAD_NUMBER,
    NOTIFICATIONS_TOGGLE_LIST,
} from './contants';

export const toggleNotificationsList = (state: boolean | null = null) => ({
    type: NOTIFICATIONS_TOGGLE_LIST,
    payload: {listDisplayed: state}
});

export const setUnreadNotificationsNumber = (number: number) => ({
    type: NOTIFICATIONS_SET_UNREAD_NUMBER,
    payload: {unreadNumber: number}
});

export const markNotificationAsRead = (id: string) => {
    return {type: NOTIFICATIONS_MARK_AS_READ, payload: {id}};
};

export const newNotificationCreated = () => {
    return {type: NOTIFICATIONS_NEW_ONE_CREATED};
};
